<template>
  <section>
    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
      <div class="box">
        <div class="box-body">
          <div class="row">
            <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
              <div class="alert" :class="'alert-' + flashType">
                {{ flashMessage }}
              </div>
            </div>
          </div>
          <div id="details" class="row">
            <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.reportType)">
                    <label>Report Type</label>
                    <!-- @change="getSelectiveStation" -->
                    <select v-model="reportgeneration.reportType" required name="reportType" class="form-control">
                      <option value="logbook">Vehicle Log Book</option>
                      <option value="hcv_ms">Data HCV Mother Station</option>
                      <option value="hcv_dbs">Data HCV DB Station</option>
                      <option value="dsr">Daily Sales Report</option>
                      <option value="driver">Driver Compliance Report</option>
                      <option value="vehicle">Vehicle Compliance Report</option>
                      <option value="trip_analysis">Vehicle Compliance Report</option>
                      <!-- <option value="consolidatedSales">Consolidated Sales Report</option> -->
                    </select>
                    <field-messages name="reportType" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">Report Type is a required field</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.downloadType)">
                    <label>Download Type</label>
                    <select v-model="reportgeneration.downloadType" required name="downloadType" class="form-control">
                      <option value="PDF">PDF</option>
                      <option value="XLSX">Excel</option>
                    </select>
                    <field-messages name="downloadType" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">
                        Download Type is a required field
                      </div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-md-12">
                <legend class="col-md-12">Report Criterion</legend>
                <div class="col-sm-12">
                  <div class="col-sm-6">
                    <label>Record Start Date</label>
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.startDate)">
                      <date-picker v-if="this.reportgeneration.reportType != 'dsr'" id="startDate"
                        v-model="reportgeneration.startDate" lang="en" name="startDate" required
                        input-class="form-control" width="100%" format="DD-MM-YYYY"></date-picker>
                      <VueCtkDateTimePicker v-if="this.reportgeneration.reportType == 'dsr'" id="startDate"
                        v-model="reportgeneration.startDate" lang="en" name="startDate" required
                        input-class="form-control" width="100%" format="MM-DD-YYYY hh:mm a"></VueCtkDateTimePicker>
                      <field-messages name="startDate" show="$touched || $submitted" class="form-control-feedback">
                        <div slot="required">
                          Record Start Date is a required field
                        </div>
                      </field-messages>
                    </validate>
                  </div>
                  <div class="col-sm-6">
                    <label>Record End Date</label>
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.endDate)">
                      <date-picker v-if="this.reportgeneration.reportType != 'dsr'" id="endDate"
                        v-model="reportgeneration.endDate" lang="en" name="endDate" required input-class="form-control"
                        width="100%" format="DD-MM-YYYY"></date-picker>
                      <VueCtkDateTimePicker v-if="this.reportgeneration.reportType == 'dsr'" id="endDate"
                        v-model="reportgeneration.endDate" lang="en" name="endDate" required input-class="form-control"
                        width="100%" format="MM-DD-YYYY hh:mm a"></VueCtkDateTimePicker>
                      <field-messages name="endDate" show="$touched || $submitted" class="form-control-feedback">
                        <div slot="required">
                          Record End Date is a required field
                        </div>
                      </field-messages>
                    </validate>
                  </div>
                </div>
                <div class="col-sm-12">
                  <!-- <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.gaManager)">
                                            <label>GA Head</label>
                                            <select v-model="reportgeneration.gaManager" required name="gaManager" class="form-control">
                                                <option disabled>Select GA Head</option>
                                                <option v-for="(item,index) in ga_managers" :key="index" :value="item.key">
                                                    {{item.value}}
                                                </option>
                                            </select>
                                            <field-messages name="gaManager" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">GA Head is a required field</div>
                                            </field-messages> 
                                        </validate>
                                    </div> -->
                  <div class="col-sm-6">
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.region)">
                      <label>Geographical Area</label>
                      <select v-model="reportgeneration.region" :disabled="isGADisable" required name="region"
                        class="form-control" @change="getStationList">
                        <option disabled>Select G.A</option>
                        <option v-for="(item, index) in region_list" :key="index" :value="item.key">
                          {{ item.value }}
                        </option>
                      </select>
                      <field-messages name="region" show="$touched || $submitted" class="form-control-feedback">
                        <div slot="required">G.A is a required field</div>
                      </field-messages>
                    </validate>
                  </div>
                  <!-- <div class="col-sm-6"
                    v-if="this.reportgeneration.reportType != 'driver' || this.reportgeneration.reportType != 'driver' || this.reportgeneration.reportType != 'vehicle'">
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.station)">
                      <label>Location</label>
                      <select v-model="reportgeneration.station" required name="station" class="form-control">
                        <option disabled>Select Location</option>
                        <option v-for="(item, index) in station_list" :key="index" :value="item.key">
                          {{ item.value }}
                        </option>
                      </select>
                      <field-messages name="station" show="$touched || $submitted" class="form-control-feedback">
                        <div slot="required">Location is a required field</div>
                      </field-messages>
                    </validate>
                  </div> -->
                  <div class="col-sm-6"
                    v-if="reportgeneration.reportType !== 'driver' && reportgeneration.reportType !== 'vehicle'">
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.station)">
                      <label>Location</label>
                      <select v-model="reportgeneration.station" required name="station" class="form-control">
                        <option disabled>Select Location</option>
                        <option v-for="(item, index) in station_list" :key="index" :value="item.key">
                          {{ item.value }}
                        </option>
                      </select>
                      <field-messages name="station" show="$touched || $submitted" class="form-control-feedback">
                        <div slot="required">Location is a required field</div>
                      </field-messages>
                    </validate>
                  </div>
                  <div class="col-sm-6">
                    <validate auto-label class="form-group" v-if="reportgeneration.reportType == 'logbook'"
                      :class="fieldClassName(formstate.vehicleId)">
                      <label>Vehicle</label>
                      <select v-model="reportgeneration.vehicleId" name="vehicleId" class="form-control"
                        :disabled="this.disabledInput">
                        <option value="" disabled>Select Vehicle</option>
                        <option v-for="(item, index) in vehicle_no" :key="index" :value="item.key">
                          {{ item.value }}
                        </option>
                      </select>
                    </validate>
                  </div>
                </div>
              </div>
            </vue-form>
            <div class="col-sm-12 text-right">
              <router-link :to="{ name: 'Report' }">
                <button class="mr-5 btn btn-default" type="button">
                  Cancel
                </button>
              </router-link>
              <button class="mr-2 btn gredientbt" type="submit" @click="createReport"
                :disabled="!(formstate.$dirty && formstate.$valid)">
                Generate Report
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import {
  formService,
  eventBus,
  reportgenerationService,
  authService,
} from '../../../services';
import { EVENTS } from '../../../config';
import axios from 'axios';
import moment from 'moment';
import Config, { USER_ROLES } from '../../../config';

export default {
  name: 'ReportCreate',
  data() {
    return {
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: EVENTS,
      formstate: {},
      station_list: {},
      region_list: {},
      ga_managers: {},
      vehicle_no: {},
      disabledInput: false,
      isGADisable: false,
      boolean: false,
      reportgeneration: {},
      generatedBy: '',
      regionManagersIdList: [],
    };
  },
  mounted: function () {
    // this.getGAHead();
    this.getRegionList();
    // this.getVehicle()
  },
  created() {
    let regionDetails = this.$store.state.auth.userRegion.regionDetails;
    if (regionDetails && regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(item => item._id);

    }
  },
  methods: {
    fieldClassName: formService.fieldClassName,

    getGAHead() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      params.roleRank = 2;
      let gaHeadList = [];
      this.$userRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            gaHeadList = res.data.docs.map(item => {
              return {
                key: item._id,
                value: item.firstName + ' ' + item.lastName,
              };
            });
          }
          this.ga_managers = gaHeadList;
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Get GA Head list failed', 'Error!');
        });
    },
    getRegionList() {
      this.loading = true;
      const params = {};
      if (this.user.roleName === 'GA Head') {
        params.regionManager = this.user._id;
      }
      if (this.user.roleName == 'Journey Manager') {
        params.journeyManager = `["${this.user._id}"]`;
      }
      params.$limit = 0;
      let regionlist = [];
      this.$regionDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            if (this.user.roleName === 'Journey Manager' || this.user.roleName == 'GA Head') {
              regionlist = res.data.docs.map(item => {
                if (this.regionManagersIdList.includes(item._id)) {
                  regionlist.push({
                    key: item._id,
                    value: item.name,
                  });
                }
                this.region_list = regionlist;

              });
            } else {
              regionlist = res.data.docs.map(item => {
                return {
                  key: item._id,
                  value: item.name,
                };
              });
              this.region_list = regionlist;
            }
          }
        })
        .catch(error => {
          this.loading = false;
          console.error('Region.requestFunction-error:', error);
          this.$snotify.error('Get region list failed', 'Error!');
        });
    },
    getSelectiveStation(e) {
      const params = {};
      params.$limit = 0;
      if (this.reportgeneration.region) {
        params.region = this.reportgeneration.region;
      }
      if (e.target.value == 'hcv_ms') {
        params.siteType = 'MS';
      }
      if (e.target.value == 'hcv_dbs' || e.target.value == 'dsr') {
        params.siteType = 'DBS';
      }
      let stationlist = [];
      this.$siteDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            stationlist = res.data.docs.map(item => {
              return {
                key: item._id,
                value: item.siteName,
              };
            });
          }
          this.station_list = stationlist;
          if (this.user.roleName == 'Journey Manager') {
            this.getStationList();
          }
        })
        .catch(error => {
          this.loading = false;
          console.error('Site.requestFunction-error:', error);
          this.$snotify.error('Get station list failed', 'Error!');
        });
    },
    getStationList(e) {
      if (this.reportgeneration.reportType !== 'driver' && this.reportgeneration.reportType !== 'vehicle') {
        const params = {};
        params.$limit = 0;
        this.user.roleName != 'Journey Manager' ? (params.region = e.target.value) : (params.region = this.region_list[0].key);
        if (this.reportgeneration.reportType == 'hcv_ms') {
          params.siteType = 'MS';
        }
        if (
          this.reportgeneration.reportType == 'hcv_dbs' || this.reportgeneration.reportType == 'dsr') {
          params.siteType = 'DBS';
        }
        let stationlist = [];
        this.$siteDataRepository
          .list(params)
          .then(res => {
            this.loading = false;
            if (res.data.docs) {
              stationlist = res.data.docs.map(item => {
                return {
                  key: item._id,
                  value: item.siteName,
                };
              });
            }
            this.station_list = stationlist;
          })
          .catch(error => {
            this.loading = false;
            console.error('Site.requestFunction-error:', error);
            this.$snotify.error('Get station list failed', 'Error!');
          });
      }
      if (this.reportgeneration.reportType == 'logbook') {
        let vehicleList = [];
        const params1 = {};
        params1.$limit = 0;
        this.user.roleName == 'Journey Manager'
          ? (params1.region = this.region_list[0].key)
          : (params1.region = e.target.value);
        this.$vehicleDataRepository
          .list(params1)
          .then(res => {
            this.loading = false;
            if (res.data.docs) {
              vehicleList = res.data.docs.map(item => {
                return {
                  key: item._id,
                  value: item.regNo,
                };
              });
            }
            this.vehicle_no = vehicleList;
          })
          .catch(error => {
            this.loading = false;
            console.error('vehicle.requestFunction-error:', error);
            this.$snotify.error('Get vehicle list failed', 'Error!');
          });
      }
    },
    createReport() {
      this.loading = true;
      if (this.reportgeneration.vehicleId == 'all') {
        this.boolean = true;
        delete this.reportgeneration.vehicleId;
      }
      this.reportgeneration.startDate = new Date(
        this.reportgeneration.startDate,
      );
      this.reportgeneration.endDate = new Date(this.reportgeneration.endDate);

      this.reportgeneration = {
        ...this.reportgeneration,
        generatedBy: this.user._id,
        allVehicle: this.boolean,
      };
      return reportgenerationService
        .addReport(this.reportgeneration)
        .then(response => {
          this.loading = false;
          this.flash = false;
          this.$snotify.success('Report generated!', 'Success!');
          this.$router.push('/reports');
          if (
            response.reportType == 'hcv_ms' ||
            response.reportType == 'hcv_dbs'
          ) {
            axios({
              method: 'get',
              url: `${Config.serverURI}/report?reportType=${response.reportType}&downloadType=${response.downloadType}&startDate=${response.startDate}&endDate=${response.endDate}&station=${response.station}&region=${response.region}&reportCode=${response.reportCode}`,
              responseType: 'arraybuffer',
            }).then(response => {
              console.log('response of download', response);
            });
          } else if (response.reportType == 'dsr') {
            axios({
              method: 'get',
              url: `${Config.serverURI}/report?reportType=${response.reportType}&downloadType=${response.downloadType}&startDate=${response.startDate}&endDate=${response.endDate}&station=${response.station}&region=${response.region}&reportCode=${response.reportCode}`,
              responseType: 'arraybuffer',
            }).then(response => {
              console.log('response of download', response);
            });
          } else if (response.reportType == 'logbook') {
            if (response.vehicleId) {
              axios({
                method: 'get',
                url: `${Config.serverURI}/report?reportType=${response.reportType}&downloadType=${response.downloadType}&startDate=${response.startDate}&endDate=${response.endDate}&region=${response.region}&reportCode=${response.reportCode}&vehicleId=${response.vehicleId}&allVehicle=${response.allVehicle}`,
                responseType: 'arraybuffer',
              }).then(response => {
                console.log('response of download', response);
              });
            } else {
              axios({
                method: 'get',
                url: `${Config.serverURI}/report?reportType=${response.reportType}&downloadType=${response.downloadType}&startDate=${response.startDate}&endDate=${response.endDate}&region=${response.region}&reportCode=${response.reportCode}&allVehicle=${response.allVehicle}`,
                responseType: 'arraybuffer',
              }).then(response => {
                console.log('response of download', response);
              });
            }
          } else if (response.reportType == 'vehicle' || response.reportType == 'driver') {
            axios({
              method: 'get',
              url: `${Config.serverURI}/report?reportType=${response.reportType}&downloadType=${response.downloadType}&startDate=${response.startDate}&endDate=${response.endDate}&region=${response.region}&reportCode=${response.reportCode}`,
              responseType: 'arraybuffer',
            }).then(response => {
              console.log('response of download', response);
            });

          }else if (response.reportType == 'trip_analysis' ) {
            axios({
              method: 'get',
              url: `${Config.serverURI}/report?reportType=${response.reportType}&downloadType=${response.downloadType}&startDate=${response.startDate}&endDate=${response.endDate}&station=${response.station}&region=${response.region}&reportCode=${response.reportCode}`,
              responseType: 'arraybuffer',
            }).then(response => {
              console.log('response of download', response);
            });

          }
        });
    },
    fieldClassName: function (field) {
      if (!field) {
        return '';
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return 'has-success';
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return 'has-danger';
      }
    },
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },
};
</script>

<style scoped>
.required-field>label::after {
  content: '*';
  color: red;
  margin-left: 0.25rem;
}

.form-control-feedback {
  font-weight: 100;
  color: red;
  position: initial;
  text-align: left;
  height: auto;
  width: auto;
}

.has-danger {
  color: red;
}

.gredientbt {
  background-image: linear-gradient(to right,
      rgba(38, 153, 251),
      rgba(146, 205, 255));
  color: white;
}
</style>



// WEBPACK FOOTER //
// ReportCreate.vue?a9f02a9e